
import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import SpinnerOverlay from '../Ui/SpinnerOverlay';
import LoginError from '../Authentication/LoginError';
import md5 from 'js-md5';
import { useDispatch } from 'react-redux';
import { actionUI } from '../../store/ui-reducer';


const ADMIN_EMAIL_HASHES = [
  '827e76d6f3d71300eb2d377ed6c4d428', 
  'dd6c33a93509297a15b0ccc4b679d640',
  '1df073a067b9da40196043a08043e0d3'  
];


const RESTRICTED_URLS = [
  "/creationSimplifySetup",
  "/setupConfiguration",
  "/simplifyaAccountsList",
  "/simplifySetup/:accountId/:env/:isExistantSetup/:status",
  '/accountApi/:env/:id/'
];

const ProtectedRoute = ({ component: Component, user, restricted, ...args }) => {
  const dispatch = useDispatch();


  useEffect(() => {
    if (user?.email) {
      const emailDomain = user.email.split('@')[1];
      const emailHash = md5(emailDomain);
      const isAdmin = ADMIN_EMAIL_HASHES.includes(emailHash);
      dispatch(actionUI.handleIsBeyableAccount(isAdmin));
    }
  }, [user?.email, dispatch]);

  // Check if current user is admin
  const email = user?.email || 'notAth@notAth.com';
  const emailDomain = email.split('@')[1];
  const emailHash = md5(emailDomain);
  const isAdminUser = ADMIN_EMAIL_HASHES.includes(emailHash);

  // Restrict non-admin users from certain paths
  if (!isAdminUser && RESTRICTED_URLS.includes(args.path)) {
    return <LoginError />
  }

  // Check for auth errors
  if (args.location.search && args.location.search.includes("?error=unauthorized")) {
    return <LoginError />
  }

  // Render the route
  return (
    <>
      {restricted ? (
        <Route
          component={withAuthenticationRequired(Component, {
            onRedirecting: () => <SpinnerOverlay />,
          })}
          {...args}
        />
      ) : (
        <Route
          component={Component}
          {...args}
        />
      )}
    </>
  );
}
export default ProtectedRoute;
